export default "__VITE_ASSET__DTufQp9m__"